import { setTerm } from './helpers';

export const setSpecialPromo = setTerm('is_special_promo');
